<div class="item-details">
  <div class="prime-table mt-2">
    <div *ngIf="routeDetails" class="mb-1 d-flex justify-content-between">
      <div class="legend d-flex align-items-center flex-wrap">
        <span class="me-2 ms-2"><span class="color-indication abouttobreach me-1"></span>Early</span>
        <span class="me-2"><span class="color-indication ontime me-1"></span>On Time</span>
        <span class="me-2"><span class="color-indication breached me-1"></span>Breached</span>
        <span class="me-2"><span class="color-indication abouttobreach me-1"></span>About to Breach</span>
    
        <span class="mx-2">|</span>
    
        <div class="d-flex align-items-center gap-2 route-info">
          <span>Route Name -<b> {{ routeDetails?.route_label }}</b></span>
          <span>Route State -<b> {{ routeDetails?.route_state }}</b></span>
          <span>Route Begin -<b> {{ routeDetails?.route_time_window?.begin | dateFormat : 'datetime'
            }}</b></span>
          <span>Route End -<b> {{ routeDetails?.route_time_window?.end | dateFormat : 'datetime' }}</b></span>
        </div>
      </div>
      <div class="pointer-cursor wrap-btn">
        <img width="20" (click)="wrapUnwrap = !wrapUnwrap"  height="20" pTooltip="Wrap/Unwrap" tooltipPosition="left" positionStyle="fixed"
          src="./assets/image/wrap.svg" alt="wrap/unwrap" />
      </div>
    </div>
    <button *ngIf="!routeDetails" type="button" class="btn btn-primary-outline mb-3 text-end" (click)="printTable()">Print</button>
    <div *ngIf="isLoading" class="text-center no-record-label" role="status">Loading...</div>
    <p-table
      *ngIf="!isLoading"
      (onPage)="onPageChange($event)"  columnResizeMode="expand"  [columns]="itemColumnNames" 
      [resizableColumns]="true" [scrollable]="true" scrollHeight="400px" sortField="task_sequence" [sortOrder]="1"
      [value]="itemDetails" [first]="first" [paginator]="paginator" [rows]="rows" [rowsPerPageOptions]="[10,25,50,75,100]"
      paginatorDropdownAppendTo="body">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngIf="routeDetails" id="color-indication" style="width: 2rem;"></th>
          <th *ngIf="!routeDetails" id="color-indication" style="width: 2rem;"><i class="pi pi-flag" pTooltip="Shipment Indicators"></i></th>
          <ng-container *ngFor="let col of columns">
            <th *ngIf="col.field !== 'task_time_window' && col.field !== 'photo_delivery_flow'"
              [ngClass]="wrapUnwrap ? 'breakWrapData' : 'wrapData'" pResizableColumn
              style="text-align: left;min-width:80px !important;" [pSortableColumn]="col.field" [id]="col">
              {{ col.header }} <p-sortIcon [field]="col.field" />
            </th>
            <th *ngIf="col.field === 'task_time_window' || col.field === 'photo_delivery_flow'"
              [ngClass]="wrapUnwrap ? 'breakWrapData' : 'wrapData'" pResizableColumn
              style="text-align: left;min-width:80px !important;" [id]="col">
              {{ col.header }}
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td *ngIf="routeDetails">
            <span class="color-indication"
            [pTooltip]="rowData['status']"
            [ngClass]="{
                    'breached': rowData['status'] === status.Breached,
                    'ontime': rowData['status'] === status.OnTime,
                    'abouttobreach': rowData['status'] === status.AboutToBreach || rowData['status'] === status.Early,
                  }"></span>
          </td>
          <td *ngIf="!routeDetails">
             @if(rowData?.is_same_day_shipment) {
                <img src="assets/image/same_day_icon.svg" 
                pTooltip="Same Day Delivery" class="align-middle label-less-icon" width="16" height="16" alt="same_day_shipment" />
              }
          </td>
          <td [ngClass]="wrapUnwrap ? 'breakWrapData' : 'wrapData'" style="text-align: left;"
            *ngFor="let col of columns">
            <span *ngIf="col.field !== 'pn_item_id' && col.field !== 'photo_delivery_flow'"> {{ rowData[col.field]
              }}</span>
            <span *ngIf="col.field === 'pn_item_id'">
              <a href="javascript:void(0)" (click)="barcodeClicked(rowData)">{{ rowData[col.field] }}</a>
              <ngx-barcode6 *ngIf="showBarcode" class="barcode-ngx" [bc-height]="20" [bc-value]="rowData.pn_item_id" [bc-display-value]="false"></ngx-barcode6>
            </span>
            <span *ngIf="col.field === 'photo_delivery_flow'">
              <i *ngIf="rowData.photo_delivery_flow" class="pi pi-camera"
                (click)="openDIAImage(rowData.photo_delivery_flow)"></i>
            </span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="itemColumnNames.length">
            <div class="text-center">
              No Records found.
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>

  </div>
</div>

<p-dialog header="Image Captured" [resizable]="false" height="500" [draggable]="false"
  [(visible)]="showPhotoDeliveryFlow" [modal]="true" [appendTo]="'body'" 
   [style]="{ width: '40vw','min-height':'350px'}">
  <div *ngIf="photoDeliveryFlow" class="signature text-center">
    <img [src]="photoDeliveryFlow" style="height: 250px; width: 60%;" alt="pdeliveryflow" />
  </div>
</p-dialog>